import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
  {
    id: 'group0',
    title: 'การจัดการข้อมูลหลัก',
    type: 'group',
    children: [
      {
        id: 'menu00',
        title: 'บริษัท',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/companies/list-companies/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu01',
        title: 'ศูนย์บริการ',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/branches/list-branch/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu02',
        title: 'กลุ่มสินค้า',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/product-groups/list-product-group/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu03',
        title: 'ประเภทสินค้า',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/product-types/list-product-types/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu04',
        title: 'สินค้า',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/products/list-products/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu05',
        title: 'เอกสารแนบ',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/document-attachments/list-documents/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu06',
        title: 'เหตุผล',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/reason-codes/list-reason-code/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu07',
        title: 'Lookup',
        type: 'item',
        icon: 'settings_applications',
        url: '/master/lookups/list-lookups/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      // {
      //   id: 'commission-setting',
      //   title: 'ตั้งค่าคอมมิชชั่น',
      //   type: 'item',
      //   icon: 'layers',
      //   url: '/commissions/commission-setting',
      //   pages: [
      //     {
      //       code: 'form',
      //       name: 'ฟอร์ม',
      //       buttons: [
      //       ]
      //     }
      //   ]
      // },
    ]
  },
  {
    id: 'group1',
    title: 'การลงทะเบียนทีมขาย',
    type: 'group',
    children: [
      // {
      //   id: 'menu11',
      //   title: 'เพิ่มข้อมูลผู้สมัคร',
      //   type: 'item',
      //   icon: 'layers',
      //   url: '/sales/sale-register/create'
      // },
      // {
      //   id: 'menu12',
      //   title: 'รายการผู้สมัคร',
      //   type: 'item',
      //   icon: 'layers',
      //   url: '/sales/sale-register/index',
      //   pages: [
      //     {
      //       code: 'list',
      //       name: 'รายการ',
      //       buttons: [
      //         {
      //           action: 'add',
      //           name: 'สร้างรายการใหม่'
      //         }
      //       ]
      //     },
      //     {
      //       code: 'form',
      //       name: 'ฟอร์ม',
      //       buttons: [
      //         {
      //           action: 'add',
      //           name: 'สร้าง'
      //         },
      //         {
      //           action: 'save',
      //           name: 'บันทึก'
      //         },
      //         {
      //           action: 'check',
      //           name: 'ตรวจสอบ'
      //         },
      //         {
      //           action: 'cancel',
      //           name: 'ยกเลิก'
      //         },
      //         {
      //           action: 'reject',
      //           name: 'ไม่อนุมัติ'
      //         },
      //         {
      //           action: 'approve',
      //           name: 'อนุมัติ'
      //         },
      //         {
      //           action: 'approvewithcondition',
      //           name: 'อนุมัติมีเงื่อนไข'
      //         },
      //         {
      //           action: 'sendback',
      //           name: 'ส่งกลับ'
      //         },
      //         {
      //           action: 'submit',
      //           name: 'ส่งข้อมูล'
      //         },
      //         {
      //           action: 'sap',
      //           name: 'ส่ง SAP'
      //         },
      //         {
      //           action: 'addfile',
      //           name: 'แนบไฟล์'
      //         },
      //         {
      //           action: 'removefile',
      //           name: 'ลบไฟล์'
      //         }
      //       ]
      //     }
      //   ]
      // },
      {
        id: 'menu44',
        title: 'รายการผู้สมัคร V2',
        type: 'item',
        icon: 'layers',
        url: '/sales/sale-register-v2/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'add',
                name: 'สร้าง'
              },
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'check',
                name: 'ตรวจสอบ'
              },
              {
                action: 'cancel',
                name: 'ยกเลิก'
              },
              {
                action: 'reject',
                name: 'ไม่อนุมัติ'
              },
              {
                action: 'approve',
                name: 'อนุมัติ'
              },
              {
                action: 'approvewithcondition',
                name: 'อนุมัติมีเงื่อนไข'
              },
              {
                action: 'sendback',
                name: 'ส่งกลับ'
              },
              {
                action: 'submit',
                name: 'ส่งข้อมูล'
              },
              {
                action: 'sap',
                name: 'ส่ง SAP'
              },
              {
                action: 'addfile',
                name: 'แนบไฟล์'
              },
              {
                action: 'removefile',
                name: 'ลบไฟล์'
              }
            ]
          }
        ]
      },
      {
        id: 'menu14',
        title: 'อนุมัติผู้สมัคร',
        type: 'item',
        icon: 'layers',
        url: '/sales/sale-register-approve/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'add',
                name: 'สร้าง'
              },
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'check',
                name: 'ตรวจสอบ'
              },
              {
                action: 'cancel',
                name: 'ยกเลิก'
              },
              {
                action: 'reject',
                name: 'ไม่อนุมัติ'
              },
              {
                action: 'approve',
                name: 'อนุมัติ'
              },
              {
                action: 'approvewithcondition',
                name: 'อนุมัติมีเงื่อนไข'
              },
              {
                action: 'sendback',
                name: 'ส่งกลับ'
              },
              {
                action: 'submit',
                name: 'ส่งข้อมูล'
              },
              {
                action: 'sap',
                name: 'ส่ง SAP'
              },
              {
                action: 'addfile',
                name: 'แนบไฟล์'
              },
              {
                action: 'removefile',
                name: 'ลบไฟล์'
              }
            ]
          }
        ]
      },
      {
        id: 'menu15',
        title: 'รายการพนักงานขาย',
        type: 'item',
        icon: 'layers',
        url: '/sales/sale-person/index',
      },
      {
        id: 'menu16',
        title: 'พนักงานขายที่ไม่มียอดขาย',
        type: 'item',
        icon: 'layers',
        url: '/sales/saleperson-zeroincome/index',
      },
      {
        id: 'menu17',
        title: 'แก้สถานะใบสมัคร',
        type: 'item',
        icon: 'layers',
        url: '/sales/sale-person/change-status/index',
      },
    ]
  },
  {
    id: 'group2',
    title: 'การขายสินค้า',
    type: 'group',
    children: [
      {
        id: 'menu22',
        title: 'รายการขาย',
        type: 'item',
        icon: 'layers',
        url: '/sellapp/sbtg-saleorder/index',
        //   badge    : {
        //       title    : '1',
        //       //translate: 'NAV.SAMPLE.BADGE',
        //       bg       : '#F44336',
        //       fg       : '#FFFFFF'
        //   }
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'add',
                name: 'สร้าง'
              },
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'check',
                name: 'ตรวจสอบ'
              },
              {
                action: 'cancel',
                name: 'ยกเลิก'
              },
              {
                action: 'reject',
                name: 'ไม่อนุมัติ'
              },
              {
                action: 'approve',
                name: 'อนุมัติ'
              },
              {
                action: 'approvewithcondition',
                name: 'อนุมัติมีเงื่อนไข'
              },
              {
                action: 'sendback',
                name: 'ส่งกลับ'
              },
              {
                action: 'submit',
                name: 'ส่งข้อมูล'
              },
              {
                action: 'sap',
                name: 'ส่ง SAP'
              },
              {
                action: 'addfile',
                name: 'แนบไฟล์'
              },
              {
                action: 'removefile',
                name: 'ลบไฟล์'
              }
            ]
          }
        ]
      },
      {
        id: 'menu40',
        title: 'รายการขาย V2',
        type: 'item',
        icon: 'layers',
        url: '/sellapp/sale-order-v2/index',
        //   badge    : {
        //       title    : '1',
        //       //translate: 'NAV.SAMPLE.BADGE',
        //       bg       : '#F44336',
        //       fg       : '#FFFFFF'
        //   }
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'add',
                name: 'สร้าง'
              },
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'createcontract',
                name: 'สร้างสัญญา'
              },
              {
                action: 'check',
                name: 'ตรวจสอบ'
              },
              {
                action: 'cancel',
                name: 'ยกเลิก'
              },
              {
                action: 'reject',
                name: 'ไม่อนุมัติ'
              },
              {
                action: 'approve',
                name: 'อนุมัติ'
              },
              {
                action: 'approvewithcondition',
                name: 'อนุมัติมีเงื่อนไข'
              },
              {
                action: 'sendback',
                name: 'ส่งกลับ'
              },
              {
                action: 'submit',
                name: 'ส่งข้อมูล'
              },
              {
                action: 'sap',
                name: 'ส่ง SAP'
              },
              {
                action: 'addfile',
                name: 'แนบไฟล์'
              },
              {
                action: 'removefile',
                name: 'ลบไฟล์'
              }
            ]
          }
        ]
      },
      {
        id: 'menu26',
        title: 'อนุมัติการขาย',
        type: 'item',
        icon: 'layers',
        url: '/sellapp/sale-order-approve/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'add',
                name: 'สร้าง'
              },
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'check',
                name: 'ตรวจสอบ'
              },
              {
                action: 'cancel',
                name: 'ยกเลิก'
              },
              {
                action: 'reject',
                name: 'ไม่อนุมัติ'
              },
              {
                action: 'approve',
                name: 'อนุมัติ'
              },
              {
                action: 'approvewithcondition',
                name: 'อนุมัติมีเงื่อนไข'
              },
              {
                action: 'sendback',
                name: 'ส่งกลับ'
              },
              {
                action: 'submit',
                name: 'ส่งข้อมูล'
              },
              {
                action: 'sap',
                name: 'ส่ง SAP'
              },
              {
                action: 'addfile',
                name: 'แนบไฟล์'
              },
              {
                action: 'removefile',
                name: 'ลบไฟล์'
              }
            ]
          }
        ]
      },
      {
        id: 'menu27',
        title: 'ปลดล็อกการรับงาน',
        type: 'item',
        icon: 'layers',
        url: '/sellapp/unlock-job/index',
      },
      {
        id: 'menu28',
        title: 'แก้สถานะใบขาย',
        type: 'item',
        icon: 'layers',
        url: '/sellapp/change-status/index',
      },
      {
        id: 'menuGroup23',
        title: 'รายงานขาย',
        type: 'group',
        icon: 'layers',
        children: [
          {
            id: 'menu23',
            title: 'รายงานขายแยกตามศูนย์',
            type: 'item',
            icon: 'layers',
            url: '/sellapp/sale-order-report01/index',
            pages: [
              {
                code: 'list',
                name: 'รายการ',
                buttons: [
                  {
                    action: 'export',
                    name: 'export'
                  }
                ]
              },
            ]
          },
          {
            id: 'menu24',
            title: 'รายงานขายแยกตามแผนขาย',
            type: 'item',
            icon: 'layers',
            url: '/sellapp/sale-order-report02/index',
            pages: [
              {
                code: 'list',
                name: 'รายการ',
                buttons: [
                  {
                    action: 'export',
                    name: 'export'
                  }
                ]
              },
            ]
          },
          {
            id: 'menu25',
            title: 'รายงานขายแยกตามวันที่',
            type: 'item',
            icon: 'layers',
            url: '/sellapp/sale-order-report03/index',
            pages: [
              {
                code: 'list',
                name: 'รายการ',
                buttons: [
                  {
                    action: 'export',
                    name: 'export'
                  }
                ]
              },
            ]
          },
          {
            id: 'menu29',
            title: 'ข้อมูลการขาย',
            type: 'item',
            icon: 'layers',
            url: '/sellapp/sale-order-list'
          }
        ]
      },
    ]
  },
  // {
  //   id: 'group7',
  //   title: 'การเช่าพื้นที่',
  //   type: 'group',
  //   children: [
  //     {
  //       id: 'menu70',
  //       title: 'ข้อมูลการเช่าพื้นที่',
  //       type: 'item',
  //       icon: 'layers',
  //       url: '/sellapp/rent-space/index',
  //       pages: [
  //         {
  //           code: 'form',
  //           name: 'ฟอร์ม',
  //           buttons: [
  //             {
  //               action: 'updateStatus',
  //               name: 'รอติดตั้ง'
  //             },
  //             {
  //               action: 'save',
  //               name: 'บันทึก'
  //             },
  //             {
  //               action: 'cancel',
  //               name: 'ยกเลิก'
  //             },
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       id: 'menu71',
  //       title: 'กำหนดวันติดตั้งตู้น้ำ',
  //       type: 'item',
  //       icon: 'layers',
  //       url: '/sellapp/rent-space/admin',
  //       pages: [
  //         {
  //           code: 'form',
  //           name: 'ฟอร์ม',
  //           buttons: [
  //             {
  //               action: 'updateStatus',
  //               name: 'ติดตั้งเสร็จสิ้น'
  //             },
  //             {
  //               action: 'save',
  //               name: 'บันทึก'
  //              },
  //             {
  //               action: 'cancel',
  //               name: 'ยกเลิก'
  //             },
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       id: 'menu72',
  //       title: 'กรอกเลขที่สัญญา',
  //       type: 'item',
  //       icon: 'layers',
  //       url: '/sellapp/rent-space/contract',
  //       pages: [
  //         {
  //           code: 'form',
  //           name: 'ฟอร์ม',
  //           buttons: [
  //             {
  //               action: 'updateStatus',
  //               name: 'สมบูรณ์'
  //             },
  //             {
  //               action: 'save',
  //               name: 'บันทึก'
  //             },
  //             {
  //               action: 'cancel',
  //               name: 'ยกเลิก'
  //             },
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       id: 'menu73',
  //       title: 'รายงานการเช่าพื้นที่ตู้',
  //       type: 'item',
  //       icon: 'layers',
  //       url: '/sellapp/rentspace-report/index',
  //       pages: [
  //         {
  //           code: 'list',
  //           name: 'รายการ',
  //           buttons: [
  //             {
  //               action: 'export',
  //               name: 'export'
  //             }
  //           ]
  //         },
  //       ]
  //     }
  //   ]
  // },

  {
    id: 'group3',
    title: 'คอมมิชชั่น',
    type: 'group',
    children: [
      {
        id: 'menu80',
        title: 'คำนวณคอมมิชชั่น',
        type: 'item',
        icon: 'layers',
        url: '/commissions/commission-salesorder/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
            ]
          }
        ]
      },
      {
        id: 'menu81',
        title: 'ตรวจสอบคอมมิชชั่น',
        type: 'item',
        icon: 'layers',
        url: '/commissions/commission-approve/1/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
            ]
          }
        ]
      },
      {
        id: 'menu82',
        title: 'อนุมัติคอมมิชชั่น',
        type: 'item',
        icon: 'layers',
        url: '/commissions/commission-review/2/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
            ]
          }
        ]
      },
      {
        id: 'menu83',
        title: 'เอกสารหัก ณ ที่จ่าย',
        type: 'item',
        icon: 'layers',
        url: '/commissions/withoutholding-tax/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'withoutholding-tax-print',
                name: 'พิมพ์'
              },
              {
                action: 'withoutholding-tax-export',
                name: 'Export'
              },
            ]
          }
        ]
      },
      {
        id: 'menu84',
        title: 'การปรับค่าคำนวณคอมมิชชั่น',
        type: 'item',
        icon: 'layers',
        url: '/commissions/commission-import/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
            ]
          }
        ]
      },
      {
        id: 'menu85',
        title: 'ตรวจสอบ Bonus Incentive',
        type: 'item',
        icon: 'layers',
        url: '/commissions/bonusincentive/confirm/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'confirm-bonus',
                name: 'ยืนยัน'
              },
            ]
          }
        ]
      },
      // {
      //   id: 'menu88',
      //   title: 'Rerun Bonus Incentive',
      //   type: 'item',
      //   icon: 'layers',
      //   url: '/commissions/rerun-bonus-incentive',
      //   pages: [
      //     {
      //       code: 'form',
      //       name: 'ฟอร์ม',
      //       buttons: [
      //       ]
      //     }
      //   ]
      // },
      {
        id: 'menu87',
        title: 'อนุมัติ Bonus Incentive',
        type: 'item',
        icon: 'layers',
        url: '/commissions/bonusincentive/approve/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'approve-bonus',
                name: 'อนุมัติ'
              },
            ]
          }
        ]
      },
      {
        id: 'menu89',
        title: 'รายงานทำจ่ายรายวัน/รายสัปดาห์/รายเดือน',
        type: 'item',
        icon: 'description',
        url: '/commissions/excel/report',
        pages: [
          {
            code: 'list',
            name: 'ฟอร์ม',
            buttons: []
          }
        ]
      },
      {
        id: 'menu90',
        title: 'รายงานยอดจ่าย Commission',
        type: 'item',
        icon: 'description',
        url: '/commissions/pay/report',
        pages: [
          {
            code: 'list',
            name: 'รายงาน',
            buttons: [
              {
                action: 'COMMISSION_TOTAL_MONTHLY',
                name: 'รายงานสรุปยอดจ่ายคอมมิชชั่นรายเดือน'
              },
              {
                action: 'COMMISSION_BRANCH_MONTHLY',
                name: 'รายงานสรุปค่าคอมมิชชั่นรายเดือนตามศูนย์'
              },
            ]
          }
        ]
      },
    ]
  },
  {
    id: 'menu-revenue',
    title: 'ยอดขาย',
    type: 'group',
    children: [
      {
        id: 'menu-revenuelist',
        title: 'รายการบันทึกยอดขาย',
        type: 'item',
        icon: 'layers',
        url: '/revenue/revenuelist/index',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [  {
              action: 'export-revenue-xlsx',
              name: 'ปุ่ม Export'
            }
            ]
          }
        ]
      },
      {
        id: 'menu-summaryrevenuelist',
        title: 'สรุปยอดขายสินค้ารายเดือน',
        type: 'item',
        icon: 'layers',
        url: '/revenue/summaryrevenue/index'
      }
    ]
  },

  {
    id: 'user',
    title: 'จัดการผู้ใช้งาน',
    type: 'group',
    children: [
      {
        id: 'user0',
        title: 'ผู้ใช้งานสำหรับ Mobile',
        type: 'item',
        icon: 'layers',
        url: '/users/user-mobile',
        pages: [
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              }
            ]
          }
        ]
      },
      {
        id: 'user1',
        title: 'ผู้ใช้งาน',
        type: 'item',
        icon: 'layers',
        url: '/users/user',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'user2',
        title: 'กลุ่มผู้ใช้งาน',
        type: 'item',
        icon: 'layers',
        url: '/users/group',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'user3',
        title: 'สิทธิ์การใช้งาน',
        type: 'item',
        icon: 'layers',
        url: '/users/role',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'group5',
    title: 'ตั้งค่า',
    type: 'group',
    icon: 'layers',
    children: [
      {
        id: 'menu52',
        title: 'โครงสร้างทีมขาย',
        type: 'item',
        icon: 'settings_applications',
        url: '/settings/sales-structure/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu53',
        title: 'ทีมขาย',
        type: 'item',
        icon: 'settings_applications',
        url: '/settings/sales-structure-team/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              // {
              //   action: 'delete',
              //   name: 'ลบ'
              // }
            ]
          }
        ]
      },
      {
        id: 'menu54',
        title: 'แผนการขาย',
        type: 'item',
        icon: 'settings_applications',
        url: '/settings/sales-plan/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
      {
        id: 'menu86',
        title: 'อัตราค่าคอมมิชชั่น',
        type: 'item',
        icon: 'layers',
        url: '/commissions/commission-rate/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              },

            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              }
            ]
          }
        ]
      },
      // {
      //   id: 'menu55',
      //   title: 'อัตราค่าคอมมิชชั่น (เก่า)',
      //   type: 'item',
      //   icon: 'settings_applications',
      //   url: '/settings/commission-rates/index',
      //   pages: [
      //     {
      //       code: 'list',
      //       name: 'รายการ',
      //       buttons: [
      //         {
      //           action: 'add',
      //           name: 'สร้างรายการใหม่'
      //         },

      //       ]
      //     },
      //     {
      //       code: 'form',
      //       name: 'ฟอร์ม',
      //       buttons: [
      //         {
      //           action: 'save',
      //           name: 'บันทึก'
      //         },
      //         {
      //           action: 'delete',
      //           name: 'ลบ'
      //         }
      //       ]
      //     }
      //   ]
      // },

      {
        id: 'menu-targetconfig',
        title: 'ตั้งค่า Target',
        type: 'item',
        icon: 'settings_applications',
        url: '/settings/setting-target/form'
      },
      {
        id: 'menu91',
        title: 'ตั้งค่าวันหยุดประจำปี',
        type: 'item',
        icon: 'settings_applications',
        url: '/settings/annual-leave'
      },
      {
        id: 'menu56',
        title: 'อัตรา Bonus Incentive',
        type: 'item',
        icon: 'layers',
        url: '/settings/bonus-incentive/index',
        pages: [
          {
            code: 'list',
            name: 'รายการ',
            buttons: [
              {
                action: 'add',
                name: 'สร้างรายการใหม่'
              }
            ]
          },
          {
            code: 'form',
            name: 'ฟอร์ม',
            buttons: [
              {
                action: 'save',
                name: 'บันทึก'
              },
              {
                action: 'delete',
                name: 'ลบ'
              }
            ]
          }
        ]
      },
    ]
  },
  {
    id: 'group6',
    title: 'ช่วยเหลือ',
    type: 'group',
    icon: 'layers',
    children: [
      {
        id: 'menu61',
        title: 'แจ้งปัญหาการใช้งาน',
        type: 'item',
        icon: 'settings_applications',
        url: 'https://www.formpl.us/form/823706076',
        externalUrl: true,
        openInNewTab: true
      },
    ]
  }
];
